import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  chartStatus: {
    loading: false,
    noData: false
  },
  selectedFilters: {
    category: 0,
    brand: 0,
    seller: 0,
    date: 1
  },
  categories: [],
  sellers: [],
  brands: [],
  dates: [1, 2, 3, 4, 5],
  chartOptions: {
    labels: [],
    dataLabels: {
      enabled: false
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'ligth',
        type: 'vertical',
        shadeIntensity: 0.3,
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100]
      }
    },
    colors: ['#56e2cf', '#56aee3', '#307fff', '#5668e2', '#cf55e2', '#e356ae', '#e25567', '#e28955', '#e2cf56', '#aee255'],
    legend: {
      show: true,
      formatter: function (val, opts) {
        return val.substring(0, 10) + ' - ' + opts.w.globals.series[opts.seriesIndex]
      },
      position: 'right'
    },
    responsive: [{
      breakpoint: 960,
      options: {
        chart: {
          height: 450
        },
        legend: {
          floating: false,
          position: 'bottom'
        }
      }
    }],
    series: []
  }
}

const getters = {

}

let elemRef = null

const actions = {
  getChart ({commit}, filter) {
    commit('SET_loading', true)
    return new Promise((resolve, reject) => {
      if (filter.elemRef) {
        elemRef = filter.elemRef
      }
      axios.post(AppUrl, {
        task: 'loadModule',
        payload: {
          brand_id: filter.brandId,
          category_id: filter.categoryId,
          seller_id: filter.sellerId,
          date_option: filter.dateOption,
          module_id: 3
        }
      })
        .then(response => {
          console.log('Fast Moving Products Chart Load', response.data.payload)
          if (response.data.payload.series.length > 0 && response.data.payload.chartOptions.labels.length > 0) {
            commit('SET_ChartOptions', {
              series: response.data.payload.chartOptions.labels.map(Number),
              labels: response.data.payload.series
            })
            commit('SET_noData', false)
            commit('SET_loading', false)
            resolve()
          } else {
            commit('SET_noData', true)
            commit('SET_loading', false)
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
          commit('SET_loading', false)
          commit('SET_noData', true)
          resolve()
        })
    })
  },
  getCategories ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getCategory',
        payload: {
          category_name: filter.categoryName,
          seller_id: filter.sellerId,
          brand_id: filter.brandId,
          date_option: filter.dateOption,
          module_id: 3
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_categories', response.data.payload.category)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getBrands ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getBrand',
        payload: {
          brand_name: filter.brandName,
          category_id: filter.categoryId,
          date_option: filter.dateOption,
          seller_id: filter.sellerId,
          module_id: 3
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_brands', response.data.payload.brand)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getSellers ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getSeller',
        payload: {
          seller_name: filter.sellerName,
          brand_id: filter.brandId,
          category_id: filter.categoryId,
          date_option: filter.dateOption,
          module_id: 3
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_sellers', response.data.payload.seller)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}

const mutations = {
  SET_loading (state, boolean) {
    state.chartStatus.loading = boolean
  },
  SET_noData (state, bool) {
    state.chartStatus.noData = bool
    if (bool) {
      state.chartOptions.labels = []
      state.chartOptions.series = []
    }
  },
  SET_categories (state, data) {
    state.categories = data
  },
  SET_brands (state, data) {
    state.brands = data
  },
  SET_sellers (state, data) {
    state.sellers = data
  },
  SET_ChartOptions (state, filter) {
    state.chartOptions.labels = filter.labels
    state.chartOptions.series = filter.series
    if (elemRef) {
      elemRef.refresh()
    }
  },
  SET_selectedFilters (state, data) {
    state.selectedFilters[data.key] = data.value
  },
  RESET_selectedFilters (state) {
    let obj = state.selectedFilters
    for (let key in obj) {
      obj[key] = 0
      if (key === 'date') {
        obj[key] = 1
      }
    }
    state.selectedFilters = obj
  },
  RESET_currentFilter (state, data) {
    let obj = state.selectedFilters
    obj[data.key] = 0
    if (data.key === 'data') {
      obj[data.key] = 1
    }
    state.selectedFilters = obj
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/fastmoving.js